import { render } from "./ProgramOwnerHandover.vue?vue&type=template&id=36b8d24d"
import script from "./ProgramOwnerHandover.vue?vue&type=script&lang=js"
export * from "./ProgramOwnerHandover.vue?vue&type=script&lang=js"

import "./ProgramOwnerHandover.vue?vue&type=style&index=0&id=36b8d24d&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__